// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UBDP","question":"styles_question__2bD6A","description":"styles_description__18gGn"};